/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 20/01/2021
 */

import * as SessionUtils from '@/core/session_utils.js'

const createOrderRequest = () => {
    return {
        session_token: SessionUtils.getGuestUserToken(),
        invited: SessionUtils.isGuestUser(),
        cart: null,
        data_invoice: null,
        url_return: ''
    }
}

export default createOrderRequest;